
export const genders = [
  { value: 'Male', label: 'Male' },
  { value: 'Female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

export const scheduleFor = [
  { value: 'business', label: 'Business' },
  { value: 'businessBreak', label: 'Business Break' },
  { value: 'staff', label: 'Staff' },
  { value: 'staffBreak', label: 'Staff Break' },
];

export function get(options, value) {
  return (options.find((op) => {
    return op.value === value;
  }) || { label: '' }).label;
}

export function transform(arr) {
  return arr.map((element) => {
    return {
      value: element,
      label: element,
    };
  });
}
